var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEligible4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6594 24.3001L19.7194 29.2401C16.9794 31.9801 16.9794 36.4001 19.7194 39.1401C22.4594 41.8801 26.8794 41.8801 29.6194 39.1401L37.3994 31.3601C42.8594 25.9001 42.8594 17.0201 37.3994 11.5601C31.9394 6.10009 23.0594 6.10009 17.5994 11.5601L9.11937 20.0401C4.43937 24.7201 4.43937 32.3201 9.11937 37.0201",
    stroke: "#4F8AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligible4);
export default __webpack_public_path__ + "static/media/eligible4.dee498f11934c161c98c3256c94522f2.svg";
export { ForwardRef as ReactComponent };